import { MemberActions } from "#/services/memberActionTracking/memberActions"
import { useMemberActionTracking } from "#/services/memberActionTracking/useMemberActionTracking"
import { useGetRoutingInfo } from "#/components/carrot-plans/shared/useQueryRoutingInfo"
import { StateMachineReducerState } from "#/components/context/stateMachine/StateMachineTypes"
import { Workflows } from "#/components/carrot-plans/check-in/workflow.constants"
import React from "react"
import { Steps } from "#/components/carrot-plans/steps/journey/step-library"

interface WorkflowActionMapping {
  readonly [stepName: string]: MemberActions
}

interface WorkflowMappings {
  readonly [workflow: string]: WorkflowActionMapping
}

// Values should also be added to MemberActions enum in memberActions.ts
const CHECK_IN_EXPERIENCE_MAPPINGS: WorkflowActionMapping = {
  [Steps.ARE_YOU_STILL_IN_THIS_PHASE]: MemberActions.CHECK_IN_ARE_YOU_STILL_IN_THIS_PHASE_VIEWED,
  [Steps.WHERE_ARE_YOU_IN_JOURNEY_NOW]: MemberActions.CHECK_IN_WHERE_ARE_YOU_IN_JOURNEY_NOW_VIEWED,
  [Steps.PRESERVATION]: MemberActions.CHECK_IN_PRESERVATION_VIEWED,
  [Steps.WHAT_KIND_OF_JOURNEY]: MemberActions.CHECK_IN_WHAT_KIND_OF_JOURNEY_VIEWED,
  [Steps.MOST_HELPFUL]: MemberActions.CHECK_IN_MOST_HELPFUL_VIEWED,
  [Steps.GOAL_TIMEFRAME]: MemberActions.CHECK_IN_GOAL_TIMEFRAME_VIEWED,
  [Steps.DO_ANY_APPLY]: MemberActions.CHECK_IN_DO_ANY_APPLY_VIEWED,
  [Steps.PARTNER_DO_ANY_APPLY]: MemberActions.CHECK_IN_PARTNER_DO_ANY_APPLY_VIEWED,
  [Steps.ANYTHING_ELSE]: MemberActions.CHECK_IN_ANYTHING_ELSE_VIEWED,
  [Steps.ANYTHING_ELSE_SENSITIVE_SCENARIO]: MemberActions.CHECK_IN_ANYTHING_ELSE_SENSITIVE_SCENARIO_VIEWED,
  [Steps.MESSAGE_WONDERFUL]: MemberActions.CHECK_IN_MESSAGE_WONDERFUL_VIEWED
}

const WORKFLOW_ACTION_MAPPINGS: WorkflowMappings = {
  [Workflows.CHECK_IN_EXPERIENCE]: CHECK_IN_EXPERIENCE_MAPPINGS
} as const

const getMemberActionForStep = (workflow: string, stepName: string): MemberActions | undefined => {
  return WORKFLOW_ACTION_MAPPINGS[workflow]?.[stepName]
}

export const useTrackMemberActionsInRoutingFlow = (state: StateMachineReducerState) => {
  const { mutate: addMemberAction } = useMemberActionTracking()
  const routingInfoQuery = useGetRoutingInfo()

  return React.useCallback(() => {
    const workflowName = state?.present?.workflowName
    const stepName = state?.present?.name

    const memberAction = getMemberActionForStep(workflowName, stepName)

    if (memberAction) {
      addMemberAction({
        memberActionTaken: memberAction,
        metaData: {
          routingInfoId: routingInfoQuery.data?.routingInfoId
        }
      })
    }
  }, [addMemberAction, routingInfoQuery.data?.routingInfoId, state?.present?.name, state?.present?.workflowName])
}
